import React, { Fragment, useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import moment from "moment";
import Image from "next/image";
import DateIcon from "../../public/images/icons/Calendar.png";
import TimerIcon from "../../public/images/icons/Timer.png";

import Stack from "@mui/material/Stack";
import { useAppContext } from "../../AppContext";
import { useTheme } from "@mui/material/styles";

function Timings({ data }) {
  const theme = useTheme();
  const {
    url,
    themeData,
    siteData,
    themeLoading,
    siteLoading,
    themeError,
    siteError,
    changeUrl,
    updateThemeData,
    updateSiteData,
  } = useAppContext();
  const [themeCss, setThemeCss] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let custom_css =
      themeData && themeData
        ? JSON.parse(themeData && themeData.custom_css)
        : null;
    setThemeCss(custom_css);
    setLoading(false);
  }, [themeData]);

  const timingCard = {
    // borderTop: `1px solid ${theme.palette.background.borderColor}`,
    borderColor: `${theme.palette.primary.borderColor}`,
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& h2": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 20,
      color: theme.palette.primary.contrastText,
      fontWeight: 500,
      textTransform: "capitalize !important",
      marginBottom: theme.spacing(0.5),
    },
    "& h5": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 14,
      textTransform: "capitalize",
      color: theme.palette.primary.contrastText,
      fontWeight: 400,
    },
    "& h6": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 16,
      color: theme.palette.primary.location,
      fontWeight: 400,
    },
  };

  return (
    <>
      <Typography component="div" sx={timingCard}>
        <Stack
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography component="div">
            <Typography variant="h2">
              {data.only_today != "0000-00-00" ? (
                <>{moment(data.only_today).format("ddd DD MMM, YYYY")}</>
              ) : (
                <>
                  {moment(data.from_date).format("ddd DD MMM, YYYY")} -{" "}
                  {moment(data.to_date).format("ddd DD MMM")}
                </>
              )}
            </Typography>
            <Typography variant="h6">
              {data.start_time.slice(0, 5)} Hrs Onwards
            </Typography>
          </Typography>
          {data.is_21_plus == 1 && (
            <Typography component="div">
              <Image
                src="/images/icons/21.svg"
                alt="..."
                width={50}
                height={50}
              />
            </Typography>
          )}
        </Stack>
      </Typography>
    </>
  );
}

export default Timings;
